export function requirePasskeyUiMutationApproval(): void {
  throw new Error("RUNTIME_BLOCKED: passkey UI mutation approval context is not connected");
}
